module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"no":{"yes":"Ja","no":"Nei"},"en":{"yes":"Yes","no":"No"}}')
  delete Component.options._Ctor
}
